// import Vue from 'vue'
// import Vuex from 'vuex'
import axios from 'axios'

import { createStore } from 'vuex'

// Vue.use(Vuex)

export default createStore({
  state: {
    serverPath: "https://dev1.med-game.ru", //develop
    // serverPath: "https://tech2.med-game.ru", //production
    testId: 0,
    sessionId: '',
    testData: {},
    gameData: [],
    actualView: {},
    actualProperty: {},
    stepNumber: 0,
    propertyList: [],
    tolalIndicators: 0,
    numberIndicator: 0,
    feedback: {    
      isSent: false,
      useful: true,      
      complexity: 0,
      frequency: 0,
      disagreeDiagnosis: false,
      stars: 0,
      comment: '',
      interestingCase: ''
    },

    feedbackAnswers:{
      useful: ""
    },

    isFeedback: false,
    feedbackQuestions: {},

    windowHeight: window.innerHeight
  },
  getters: {
    gameData(state){
      return state.gameData
    },
    stepNumber(state){
      return state.stepNumber
    },
    actualView(state){
      return state.actualView
    },
    actualProperty(state){
      return state.actualProperty
    },
    completed(state){
      return state.actualProperty.completed
    },
    feedback(state){
      return state.feedback
    },
    tolalIndicators(state){
      return state.tolalIndicators
    },
    numberIndicator(state){
      return state.numberIndicator
    },
    windowHeight(state){
      return state.windowHeight
    }
  },
  mutations: {
    SET_TESTDATA_TO_STATE(state, testData) {
      state.testData = testData
      state.testId = testData.data.data.id
      state.sessionId = testData.data.data.session_id
    },
    SET_GAMEDATA_TO_STATE(state, gameData) {
      const feedback = gameData.find(e => e.question_type_id===3)
      if (feedback) {
        state.isFeedback = true
        state.feedbackQuestions = feedback
      }
      else{
        state.isFeedback = false
      }

      const onlyQuestionsList = gameData.filter(x => x.question_type_id === 2)
      state.gameData = onlyQuestionsList
    },
    SET_GAMEDATA_TO_STATE_LOCAL(state, gameData) {
      // const feedback = gameData.find(e => e.question_type_id===3)
      // if (feedback) {
        // state.isFeedback = true
        // state.feedbackQuestions = feedback
      // }
      // else{
        // state.isFeedback = false
      // }

      // const onlyQuestionsList = gameData.filter(x => x.question_type_id === 2)
      // state.gameData = onlyQuestionsList
      state.gameData = gameData
    },
    setStepNumber(state, stepNumber){
      state.stepNumber = stepNumber
    },
    setActualView(state, actualView){
      state.actualView = actualView
    },
    createEmptyPropertyList(state, gameDataQuestions) {
      const propertyList = state.propertyList
      if (propertyList.length > 0) {
        return        
      }
      const gameData = gameDataQuestions
      let indicatorCount = 0
      
      for (let i = 0; i < gameData.length; i++) {
        let currentProperty = {}
        
        indicatorCount += 1

        currentProperty.completed = false
        if (gameData[i].body.type === "sections") {
          currentProperty.viewedSections = []
          for (let j = 0; j < gameData[i].body.sections.length; j++) {
            indicatorCount += 1
            currentProperty.viewedSections.push(false)
          }
        }
        else if (gameData[i].body.type === "answersButtons") {
          currentProperty.currentAnswer = null
          currentProperty.numberTry = 0
        }
        else if (gameData[i].body.type === "manyAnswersButtons") {
          currentProperty.buttonsList = []
          for (let j = 0; j < gameData[i].body.bodyButtons.length; j++) {
            currentProperty.buttonsList.push(false)
          }
          currentProperty.numberTry = 0
        }
        else if (gameData[i].body.type === "answersCheckboxes") {
          currentProperty.checkboxList = []
          for (let j = 0; j < gameData[i].body.bodyCheckboxes.length; j++) {
            currentProperty.checkboxList.push(false)
          }
          currentProperty.numberTry = 0
        }
        else if (gameData[i].body.type === "answers") {
          currentProperty.answersList = []
          for (let j = 0; j < gameData[i].body.bodyAnswers.length; j++) {
            currentProperty.answersList.push(false)
          }
          currentProperty.numberTry = 0
        }
        if (gameData[i].body.acceptCheckbox) {
          currentProperty.acceptCheckbox = false
        }
        
        propertyList.push(currentProperty)
        
      }
      state.propertyList = propertyList
      state.tolalIndicators = indicatorCount
    },
    setActualProperty(state, stepNumber){
      state.actualProperty = state.propertyList[stepNumber]
    },

    setCurrentAnswer(state, answerNumber){
      state.actualProperty.currentAnswer = answerNumber
      // const oldObj = state.currentAnswersState[state.stepNumber]
      // const newObj = {...oldObj, currentAnswer: answerNumber,}
      // Vue.set(state.currentAnswersState, state.stepNumber, newObj)
    },
    setManyCurrentAnswer(state, answerNumberValue){

      // Vue.set(state.actualProperty.buttonsList, answerNumberValue.number, answerNumberValue.value)
      state.actualProperty.buttonsList[answerNumberValue.number] = answerNumberValue.value
    },
    changeAnswerCheckbox(state, checkboxNumber){      
      state.actualProperty.checkboxList[checkboxNumber] = !state.actualProperty.checkboxList[checkboxNumber]
      // Vue.set(state.actualProperty.checkboxList, checkboxNumber, !state.actualProperty.checkboxList[checkboxNumber])
    },
    setCompleted(state, completed){
      state.actualProperty.completed = completed
    },
    setFeedbackItem(state, feedbackItem){
      state.feedback[feedbackItem.name] = feedbackItem.value
    },
    setAcceptCheckbox(state, acceptCheckbox){
      state.actualProperty.acceptCheckbox = acceptCheckbox
    },
    setViewedSection(state, numberSection){
      state.actualProperty.viewedSections[numberSection] = true
    },
    increaseIndicator(state, indicatorValue){
      state.numberIndicator += indicatorValue
    },    
    clearState(state){
      state.propertyList.length = 0
      state.feedback = {    
        isSent: false,
        useful: true,      
        complexity: 0,
        frequency: 0,
        disagreeDiagnosis: false,
        stars: 0,
        comment: '',
        interestingCase: ''
      }
      state.numberIndicator = 0
    },
    setWindowHeight(state, windowHeight){
      state.windowHeight = windowHeight
    },
    setAnswer(state, index){
      state.actualProperty.answersList[index] = !state.actualProperty.answersList[index]
    },
    clearAnotherAnswers(state, index){      
      for (let i = 0; i < state.actualProperty.answersList.length; i++) {
        if (i!==index) {
          state.actualProperty.answersList[i] = false  
        }        
      }
    },
    setTrueAnswers(state){
      for (let i = 0; i < state.actualProperty.answersList.length; i++) {
        state.actualProperty.answersList[i] = state.actualView.bodyAnswers[i].isRight
      }
      
    }

  },
  actions: {
    GET_DATA_FROM_API({commit, state},testNumber){
      return axios(`${state.serverPath}/api/v1/test/${testNumber}`, {
        method: "GET"
      })
        .then((testData) => {
          commit('SET_TESTDATA_TO_STATE', testData)
          return testData.data.data.questions
        })
        .then((gameDataQuestions) => {
          commit('SET_GAMEDATA_TO_STATE', gameDataQuestions)
          return gameDataQuestions
        })
        .then((gameDataQuestions) => {
          commit('createEmptyPropertyList', gameDataQuestions)
          return gameDataQuestions
        })
        .then((gameDataQuestions) => {
          commit('setStepNumber', 0)
          return gameDataQuestions[0].body
        })
        .then((gameDataQuestionsActual) => {
          commit('setActualView', gameDataQuestionsActual)
          return 0
        })
        .then((stepNumber) => {
          commit('setActualProperty', stepNumber)
          return
        })
        .catch((error) => {
          console.log('Ошибка:');
          console.log(error)
          return error
        })
    },
    GET_DATA_FROM_LOCAL({dispatch, commit, state}, testData){
      commit('SET_TESTDATA_TO_STATE', testData)
      commit('SET_GAMEDATA_TO_STATE_LOCAL', testData.data.data.questions)
      commit('createEmptyPropertyList', testData.data.data.questions)
      commit('setStepNumber', 0)
      return dispatch('SET_ACTUAL_VIEW', state.stepNumber)
    },
    SET_ACTUAL_VIEW({dispatch, commit, state},stepNumber){
      commit('setActualView', state.gameData[stepNumber].body)
      return dispatch('SET_ACTUAL_PROPERTY', stepNumber)
    },
    SET_ACTUAL_PROPERTY({commit},stepNumber){
      commit('setActualProperty', stepNumber)
    },

    SEND_DATA_TO_API(store, dataQuestion){

      axios({
        url: `${store.state.serverPath}/api/v1/answers`,
        method: 'post',
        headers: { 'session-id':  store.state.sessionId },
        data: {
          "question_id": store.state.gameData[store.state.stepNumber].id,
          "test_id": store.state.testId,
          "body": {
            "description": dataQuestion
          }
        }
      })
      .catch(function (error) {
        console.log(error);        
      })

      if (store.state.testId < 0) {
        console.log(dataQuestion);
      }      

    },

    SEND_FEEDBACK_TO_API(store, dataQuestion){

      axios({
        url: `${store.state.serverPath}/api/v1/answers`,
        method: 'post',
        headers: { 'session-id':  store.state.sessionId },
        data: {
          "question_id": store.state.feedbackQuestions.id,
          "test_id": store.state.testId,
          "body": {
            "description": dataQuestion
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
  
      if (store.state.testId < 0) {
        console.log(dataQuestion);
      }      
  
    },
    
    setStepNumber(store, stepNumber){
      if (store.state.stepNumber !== stepNumber) {
        store.commit('setStepNumber', stepNumber)
        store.commit('setActualProperty', stepNumber)
        return store.dispatch('setActualView', store.state.gameData[stepNumber].body)
      }
    },
    setActualView(store, actualView){
      store.commit('setActualView', actualView)
      // return store.dispatch('setActualProperty', store.state.propertyList[store.state.stepNumber])
    },
    setActualProperty(store, actualProperty){
      store.commit('setActualProperty', actualProperty)
    },    
    nextStep(store){
      if (store.state.stepNumber+1 < store.state.gameData.length) {
        return store.dispatch('setStepNumber', store.state.stepNumber+1)
      }
    },
    previousStep(store){
      if (store.state.stepNumber > 0) {
        return store.dispatch('setStepNumber', store.state.stepNumber-1)
      }
    },
    returnActualView(store){
      return store.dispatch('setActualView', store.state.gameData[store.state.stepNumber].body)
    },
    setCurrentAnswer(store, answerNumber){
      store.commit('setCurrentAnswer', answerNumber)
    },
    setManyCurrentAnswer(store, answerNumberValue){
      store.commit('setManyCurrentAnswer', answerNumberValue)
    },
    changeAnswerCheckbox(store, checkboxNumber){
      store.commit('changeAnswerCheckbox', checkboxNumber)
    },
    setCompleted(store, completed){
      store.commit('setCompleted', completed)
    },
    setFeedbackItem(store, feedbackItem){
      store.commit('setFeedbackItem', feedbackItem)
    },
    setAcceptCheckbox(store, acceptCheckbox){
      store.commit('setAcceptCheckbox', acceptCheckbox)
    },
    setViewedSection(store, numberSection){
      if (!store.state.actualProperty.viewedSections[numberSection]) {
        store.commit('setViewedSection', numberSection)
        return store.dispatch('increaseIndicator', 1)
      }      
    },
    increaseIndicator(store, indicatorValue){
      store.commit('increaseIndicator', indicatorValue)
    },
    newStart(store){      
      store.commit('clearState')
      return store.dispatch('GET_DATA_FROM_API', store.state.testId)
      // return store.dispatch('GET_DATA_FROM_LOCAL', store.state.testData)
    },
    setWindowHeight(store, windowHeight){
      store.commit('setWindowHeight', windowHeight)
    },
    setAnswer(store, index){
      store.commit('setAnswer', index)
    },
    clearAnotherAnswers(store, index){
      store.commit('clearAnotherAnswers', index)
    },
    setTrueAnswers(store){
      store.commit('setTrueAnswers')
    }
    
  },
  modules: {
  }
})
